<template>
    <div class="tournament__participation">
        <div class="tournament__participation__content">

            <div class="tournament__participation__item">

                <div class="tournament__participation__item__title">
                    <p class="item-title" :style="{backgroundImage: `url('${require('@/image/icon/icn-filter-04.svg')}')`}">
                        참가신청</p>
                </div>

                <div class="form-control-select-wrap">
                    <div class="float-content select-option">
                        <div class="form-control-select fl">
                            <p class="input-title">경기타입</p>
                            <select class="form-control-select" v-model="typeCode" @change="changeType">
                                <option :value="null">경기타입 선택</option>
                                <option v:bind-key="type.code" :value="type.code" v-for="(type) in typeList">{{type.name}}</option>
                            </select>
                        </div>

                        <div class="form-control-select fr">
                            <p class="input-title">세부종목</p>
                            <select class="form-control-select" v-model="eventCode" @change="changeEvent"
                                    ref="eventSelect">
                                <option :value="null">세부종목 선택</option>
                                <option :value="event.code" v-for="(event) in eventList">{{event.name}}</option>
                            </select>
                        </div>
                    </div>


                    <div class="float-content select-option">

                        <div class="form-control-select fl">
                            <p class="input-title">연령</p>
                            <select class="form-control-select" v-model="ageCode" @change="ageChange">
                                <option :value="null">연령 선택</option>
                                <option :value="age.ageCode" v-for="(age) in ageList">{{age.ageCode}}</option>
                            </select>
                        </div>

                        <div class="form-control-select fr">
                            <p class="input-title">구분</p>
                            <select class="form-control-select" v-model="levelCode">
                                <option :value="null">구분 선택</option>
                                <option :value="level.levelCode" v-for="(level) in levelList">{{level.levelCode}}
                                </option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>

            <div class="participation__player">
                <EmptyContent style="height: 200px;" content="경기타입 및 세부종목을 먼저 선택해주세요"
                              v-if="!typeCode || (typeCode==='PERSONAL' && !eventCode)"></EmptyContent>

                <div v-else>
                    <!--논오픈-->
                    <NonopenTournamentParticipation v-model="playerList" :type_code="typeCode"
                                                    v-if="Number(tournament.tnmtType) === 2"
                                                    :event_code="eventCode"></NonopenTournamentParticipation>
                    <!--오픈대회-->
                    <OpenTournamentParticipation v-model="playerList" v-else
                                                 :type_code="typeCode"
                                                 :event_code="eventCode"></OpenTournamentParticipation>
                </div>


            </div>

            <div class="participation__bottom">
                <div class="participation__term__list">
                    <div class="participation__term">
                        <p @click="personalInformationCollectionCheck = !personalInformationCollectionCheck"
                           :class="personalInformationCollectionCheck ? 'on' : ''"><span>개인정보 수집 이용</span>에
                            동의합니다.</p>
                    </div>
                    <div class="participation__term">
                        <p @click="personalInformationUtilizationCheck = !personalInformationUtilizationCheck"
                           :class="personalInformationUtilizationCheck ? 'on' : ''">
                            <span>개인정보 제3자 활용</span>에 동의합니다.</p>
                    </div>
                    <div class="participation__term">
                        <p @click="tournamentParticipationOutlineCheck = !tournamentParticipationOutlineCheck"
                           :class="tournamentParticipationOutlineCheck ? 'on' : ''">
                            <span>대회 참가요강</span>을 숙지하였습니다.</p>
                    </div>
                </div>
                <div class="participation__btn mlf-a" @click="participation">참가신청</div>
            </div>

        </div>
        <AlertModal v-if="validationAlertShow" :content="validationAlertContent"
                    @close="validationAlertShow=false"></AlertModal>
        <AlertModal v-if="errorAlertShow" :content="errorAlertContent" @close="errorAlertShow=false"></AlertModal>
        <AlertModal v-if="wrongParticipantAlertShow" content="참가신청을 할 수없습니다" @close="$router.back()"></AlertModal>
    </div>
</template>


<script>


    import {mapState} from 'vuex'
    import OpenTournamentParticipation from "./participation/OpenTournamentParticipation";
    import NonopenTournamentParticipation from "./participation/NonopenTournamentParticipation";
    import EmptyContent from "../common/EmptyContent";
    import participantMixin from "../../mixins/participantMixin";
    import AlertModal from "../modal/AlertModal";

    export default {
        computed: {
            ...mapState('tournaments', ['tournament']),
        },
        components: {
            AlertModal,
            EmptyContent,
            NonopenTournamentParticipation,
            OpenTournamentParticipation
        },
        mixins: [participantMixin],
        data() {
            return {
                tnmtId: this.$route.params.tnmtId,
                personalInformationCollectionCheck: false,
                personalInformationUtilizationCheck: false,
                tournamentParticipationOutlineCheck: false,

                typeList: [],
                typeCode: null,

                eventList: [],
                eventCode: null,

                ageList: [],
                ageCode: null,

                levelList: [],
                levelCode: null,

                validationAlertShow: false,
                validationAlertContent: null,

                errorAlertShow: false,
                errorAlertContent: null,
                wrongParticipantAlertShow: false,

                orgId: null,
            }
        },
        methods: {
            participation() {
                if (this.participantValidation() && this.participantPlayerValidation()) {

                    const temp = {
                        tnmtId: this.$route.params.tnmtId,
                        gameList: [{
                            tnmtTypeId: this.typeCode,
                            eventId: this.eventCode,
                            age: this.ageCode,
                            level: this.levelCode,
                            playerList: this.playerList,
                        }],
                    }

                    if (Number(this.tournament.tnmtType) === 2) {
                        temp.orgId = this.orgId
                    }
                    

                    const _this = this
                    console.dir(temp)
                    this.$store.dispatch('participants/tournamentParticipant', temp).then(res => {
                        console.dir(res)
                        const participantId = res.participantIdList[0].participantId
                        const tnmtId = _this.tournament.tnmtId
                        _this.$router.replace(`/tournament/participation/${tnmtId}/${participantId}`)
                    }).catch(err => {
                        _this.errorAlertShow = true
                        console.dir('participants/tournamentParticipant err => ')
                        console.dir(err)
                        _this.errorAlertContent = err.message || '오류가 발생했습니다. 잠시 후 시도해주세요'
                    })
                }
            },
            participantValidation() {
                let validation = true

                if (!this.typeCode) {
                    validation = false
                    this.validationAlertContent = '경기타입을 선택해주세요'
                    this.validationAlertShow = true
                } else if (this.typeCode === 'PERSONAL' && !this.eventCode) {
                    validation = false
                    this.validationAlertContent = '세부종목을 선택해주세요'
                    this.validationAlertShow = true
                } else if (!this.ageCode) {
                    validation = false
                    this.validationAlertContent = '연령을 선택해주세요'
                    this.validationAlertShow = true
                } else if (!this.levelCode) {
                    validation = false
                    this.validationAlertContent = '구분을 선택해주세요'
                    this.validationAlertShow = true
                } else if (!this.personalInformationCollectionCheck) {
                    validation = false
                    this.validationAlertContent = '개인정보 수집 이용약관에 동의해주세요'
                    this.validationAlertShow = true
                } else if (!this.personalInformationUtilizationCheck) {
                    validation = false
                    this.validationAlertContent = '개인정보 제3자 활용에 동의해주세요'
                    this.validationAlertShow = true
                } else if (!this.tournamentParticipationOutlineCheck) {
                    validation = false
                    this.validationAlertContent = '대회 참가요강 숙지에 동의해주세요'
                    this.validationAlertShow = true
                }

                return validation
            },
            participantPlayerValidation() {
                if (this.participantValidation()) {
                    let validation = true
                    let overlapCheck = true

                    // tnmtType 1 : 오픈 2: 논오픈
                    if (Number(this.tournament.tnmtType) === 2) {
                        //논오픈
                        for(let i=0; i<this.playerList.length; i++){
                            let player = this.playerList[i]

                            if(player == null){

                                validation = false

                                this.validationAlertContent = `${i+1}번째 참가자를 선택해주세요`
                                this.validationAlertShow = true
                                break;
                            }else if('userId' in player && player.userId === null){

                                validation = false

                                this.validationAlertContent = `${i+1}참가자 정보를 입력해주세요`
                                this.validationAlertShow = true
                                break;
                            }

                            if("orgId" in player){
                                this.orgId = player.orgId
                                delete this.playerList[i].orgId
                            }
                            /*for(let j=i+1; i<this.playerList.length; i++){
                                if (player.userId === this.playerList[j].userId) {

                                    validation = false
                                    this.validationAlertContent = `${j+1}참가자는 이미 등록된 참가자입니다. 다시 한번 확인해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }
                            }*/
                        }
                    } else {
                        for(let i=0; i<this.playerList.length; i++){
                            const player = this.playerList[i]
                            if(player.type === 'T'){
                                if(!player.playerName){

                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 이름이 입력되어있지않습니다. 이름을 입력해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }
                            }else{
                                if(!player.playerName){
                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 이름이 입력되어있지 않습니다. 이름을 입력해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }else if(!player.mobile){
                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 연락처가 입력되어있지 않습니다. 연락처를 입력해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }else if(!this.phoneValidation(player.mobile)){
                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 연락처형식이 올바르지 않습니다. 연락처를 알맞게 입력해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }else if(!player.gender){
                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 성별이 입력되어 있지않습니다. 성별을 선택해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }else if(!player.dateOfBirth){
                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 생년월일이 입력되어있지않습니다. 생년월일을 입력해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }else if(!this.birthValidation(player.dateOfBirth)){
                                    validation = false
                                    this.validationAlertContent = `${i+1} 번째 참가자 생년월일이 형식이 올바르지 않습니다. 생년월일을 알맞게 입력해주세요`
                                    this.validationAlertShow = true
                                    break;
                                }
                            }
                        }
                    }

                    return validation;

                }
            },
            eventGenderValidationCheck(){
              if(this.participantValidation() && this.participantPlayerValidation() && Number(this.tournament.tnmtType) === 1){
                  let genderValidationCheck = true

                  if(this.typeCode === 'PERSONAL'){
                      if(this.eventCode === 'MS' && this.playerList[0].gender !== 'M'){
                          genderValidationCheck = false

                          this.validationAlertContent = '세부종복 남성단식은 남성만 참여가능합니다'
                          this.validationAlertShow = true
                      }else if(this.eventCode === 'WS' && this.playerList[0].gender !== 'W'){
                          genderValidationCheck = false
                          this.validationAlertContent = '세부종목 여성단식은 여성만 참여가능합니다'
                          this.validationAlertShow = true
                      }else if(this.eventCode === 'MD'){
                          this.playerList.forEach(player => {
                              if(player.gender !== 'M'){
                                  genderValidationCheck = false
                              }
                          })
                          if(!genderValidationCheck){
                              this.validationAlertContent = '세부종목 남성복식은 남성만 참여가능합니다'
                              this.validationAlertShow = true
                          }
                      }else if(this.eventCode === 'WD'){

                          this.playerList.forEach(player => {
                              if(player.gender !== 'W'){
                                  genderValidationCheck = false
                              }
                          })
                          if(!genderValidationCheck){
                              this.validationAlertContent = '세부종목 여성복식은 여성만 참여가능합니다'
                              this.validationAlertShow = true
                          }

                      }else if(this.eventCode==='XD'){
                          let womanCount = 0
                          let manCount = 0
                          this.playerList.forEach(player => {
                              if(player.gender === 'W'){
                                  womanCount ++;
                              }else if(player.gender === 'M'){
                                  manCount ++;
                              }
                          })
                          if(womanCount!==1 || manCount!==1){
                              genderValidationCheck = false
                              this.validationAlertContent = '세부종목 혼합복식은 여성 1명 남성1명으로 참여가능합니다'
                              this.validationAlertShow = true
                          }
                      }
                  }

                  return genderValidationCheck
              }
            },
            birthValidation(birthDay) {
                const year = Number(birthDay.substr(0, 4)); // 입력한 값의 0~4자리까지 (연)
                const month = Number(birthDay.substr(4, 2)); // 입력한 값의 4번째 자리부터 2자리 숫자 (월)
                const day = Number(birthDay.substr(6, 2)); // 입력한 값 6번째 자리부터 2자리 숫자 (일)
                const today = new Date(); // 날짜 변수 선언
                const yearNow = today.getFullYear(); // 올해 연도 가져옴
                if (birthDay.length <= 8) {
                    // 연도의 경우 1900 보다 작거나 yearNow 보다 크다면 false를 반환합니다.
                    if (1900 > year || year > yearNow) {
                        return false;
                    } else if (month < 1 || month > 12) {
                        return false;
                    } else if (day < 1 || day > 31) {
                        return false;
                    } else if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
                        return false;
                    } else if (month == 2) {
                        var isleap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
                        if (day > 29 || (day == 29 && !isleap)) {
                            return false;
                        } else {
                            return true;
                        } //end of if (day>29 || (day==29 && !isleap))
                    } else {
                        return true;
                    }//end of if
                } else { //1.입력된 생년월일이 8자 초과할때 : auth:false
                    return false;
                }


            },
            phoneValidation(phone){
                const regExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
                return regExp.test(phone)
            },
            changeType(event) {
                const _this = this
                const value = event.target.value

                this.eventReset()
                this.ageReset()
                this.levelReset()

                if (value === 'TEAM') {
                    // this.$refs.eventSelect.attr('disabled', true)

                    this.$store.dispatch('filters/getListAge', {
                        tnmtId: this.tnmtId,
                        typeCode: this.typeCode,
                        eventCode: 'UNKNOWN'
                    }).then(res => {
                        _this.ageList = res.ageList
                    }).catch(err => {
                        console.dir(err)
                    })

                } else {

                    this.$store.dispatch('filters/getListEvent', {
                        tnmtId: this.tnmtId,
                        typeCode: value
                    }).then(res => {
                        _this.eventList = res.eventList
                    }).catch(err => {
                        console.dir(err)
                    })
                }

            },
            changeEvent(event) {
                const _this = this;
                const value = event.target.value
                this.ageReset()
                this.levelReset()
                this.$store.dispatch('filters/getListAge', {
                    tnmtId: this.tnmtId,
                    typeCode: this.typeCode,
                    eventCode: value
                }).then(res => {
                    _this.ageList = res.ageList
                }).catch(err => {
                    console.dir(err)
                })
            },
            ageChange(event) {
                const value = event.target.value
                const _this = this

                this.levelReset()
                this.$store.dispatch('filters/getListLevel', {
                    tnmtId: this.tnmtId,
                    typeCode: this.typeCode,
                    eventCode: this.eventCode,
                    ageCode: value
                }).then(res => {
                    _this.levelList = res.levelList
                }).catch(err => {
                    console.dir(err)
                })
            },


            eventReset() {
                this.eventList = []
                this.eventCode = null
            },
            ageReset() {
                this.ageList = []
                this.ageCode = null
            },
            levelReset() {
                this.levelList = []
                this.levelCode = null
            }
        },
        mounted() {
            const _this = this;
            this.$store.dispatch('filters/getListType', {tnmtId: this.$route.params.tnmtId}).then(res => {
                _this.typeList = res.typeList
            }).catch(err => {
                console.dir(err)
            })
        }
        ,
        created() {
            const _this = this;
            if (Number(this.tournament.tnmtType) !== 1 && Number(this.tournament.tnmtType) !== 2) {
                this.wrongParticipantAlertShow = true
            }
        }
    }
</script>
